import * as Yup from 'yup';
import { PqrRedirect } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrRedirect = {
    area1: '',
    person1: '',
    email1: '',
    area2: '',
    person2: '',
    email2: '',
    area3: '',
    person3: '',
    email3: '',
    redirectPqr: false,
    generateAlert: false,
    addAnnex: false,
};

export const validationSchema = Yup.object({});
